export const OVERLAY_TEXT = 'OVERLAY_TEXT'
export const OVERLAY_SPINNER = 'OVERLAY_SPINNER'
export const OVERLAY_NEWSLETTER_YES_NO = 'OVERLAY_NEWSLETTER_YES_NO'
export const OVERLAY_NEWSLETTER_SEND =   'OVERLAY_NEWSLETTER_SEND'

export const OVERLAY_EVENTS_UPDATE = 'OVERLAY_EVENTS_UPDATE'
export const OVERLAY_EVENTS_MAIL_SEND = 'OVERLAY_EVENTS_MAIL_SEND'
export const OVERLAY_EVENTS_MAIL_YES_NO = 'OVERLAY_EVENTS_MAIL_YES_NO'

export const OVERLAY_KEY_MULTISITE_SELECTOR = 'multisiteSelector'